// Dashboard.js
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext";
import axios from "axios";

export default function Dashboard() {
  const { user, logout } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("india"); // india / remote
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const token = localStorage.getItem("token");

  //added for detail search
  const normalize = (text) =>
    text.toLowerCase().replace(/[^a-z0-9\s]/g, "");
  const searchJobs = (jobs, query) => {
    const keywords = normalize(query).split(" ");
    return jobs.filter((job) => {
      const combinedText = normalize(
        `${job.title} ${job.company} ${job.description}`
      );
      return keywords.every((word) =>
        combinedText.includes(word)
      );
    });
  };
  // Then your useEffect comes AFTER
  useEffect(() => {
    if (!searchTerm) return;
    const filtered = searchJobs(jobs, searchTerm);
    setJobs(filtered);
  }, [searchTerm]);
  // Search Code end

  const fetchJobs = async (tab = activeTab, pageNum = page) => {
    try {
      const typeFilter = tab === "india" ? "Full-time India" : "Remote";
      const res = await axios.get("https://u2ujobs.coreaidataedge.com/jobs/filter", {
        headers: { Authorization: `Bearer ${token}` },
        params: { type: typeFilter, page: pageNum, perPage, keyword: searchTerm },
      });
      setJobs(res.data.jobs);
      setTotal(res.data.total);
    } catch (err) {
      console.error(err);
      setJobs([]);
      setTotal(0);
    }
  };

  useEffect(() => {
    fetchJobs(activeTab, page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, page]);

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    const totalPages = Math.ceil(total / perPage);
    if (page < totalPages) setPage(page + 1);
  };

  const handleSearch = () => {
    setPage(1);
    fetchJobs(activeTab, 1);
  };

  const renderJobCard = (job) => (
    <div key={job.link} style={{ border: "1px solid #ccc", borderRadius: 8, padding: 10, marginBottom: 10 }}>
      <h3>{job.title}</h3>
      <p>
        <strong>{job.company}</strong> - {job.location}
      </p>
      <a href={job.link} target="_blank" rel="noreferrer">View Job</a>
    </div>
  );

  const totalPages = Math.ceil(total / perPage);

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
      <h1 style={{ textAlign: "center", marginBottom: 20 }}>Welcome to U2U Systems Job Search Portal</h1>
      <h2 style={{ textAlign: "center", marginBottom: 20 }}>Search for available Internships/Fresher/Graduate Level Jobs</h2>
      <h3 style={{ textAlign: "center", marginBottom: 20 }}>Select Tab below to choose Full-Time or Remote Jobs</h3>

      {/* Tabs */}
      <div style={{ display: "flex", marginBottom: 20 }}>
        <button
          onClick={() => { setActiveTab("india"); setPage(1); }}
          style={{
            flex: 1, padding: 10,
            backgroundColor: activeTab === "india" ? "#0073b1" : "#f0f0f0",
            color: activeTab === "india" ? "#fff" : "#000",
            border: "none", cursor: "pointer",
            fontWeight: activeTab === "india" ? "bold" : "normal",
          }}
        >Full-Time India</button>

        <button
          onClick={() => { setActiveTab("remote"); setPage(1); }}
          style={{
            flex: 1, padding: 10,
            backgroundColor: activeTab === "remote" ? "#0073b1" : "#f0f0f0",
            color: activeTab === "remote" ? "#fff" : "#000",
            border: "none", cursor: "pointer",
            fontWeight: activeTab === "remote" ? "bold" : "normal",
          }}
        >Remote Global</button>
      </div>

      {/* Search */}
      <div style={{ marginBottom: 20 }}>
        <input
          type="text"
          placeholder="Search by title, company, location..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "100%", padding: 10, borderRadius: 5, border: "1px solid #ccc" }}
        />
        <button onClick={handleSearch} style={{ marginTop: 10, padding: 10 }}>Search</button>
      </div>

      {/* Job List */}
      <div>
        {jobs.length === 0 ? <p>No jobs found.</p> : jobs.map(renderJobCard)}
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
        <button onClick={handlePrev} disabled={page <= 1}>Prev</button>
        <span>Page {page} of {totalPages}</span>
        <button onClick={handleNext} disabled={page >= totalPages}>Next</button>
      </div>

      <div style={{ marginTop: 20 }}>
        <button onClick={logout} style={{ padding: 10, backgroundColor: "#d33", color: "#fff", border: "none" }}>Logout</button>
      </div>
    </div>
  );
}